import { PropTypes } from 'prop-types';
import React from 'react';

import Link from '../Link';
import Newsletter from '../Newsletter';

const ExpandedNav = ({ data, onClick, open = false }) => {
  const {
    featuredTopics = [],
    learnMore = [],
    mainNav = [],
    newsletterPlaceholder = '',
    newsletterTitle = '',
  } = data;
  const fFeaturedTopics = featuredTopics.filter(x=> x.slug !== 'empty')
  const handleClick = () => {
    onClick();
  };

  const handleBlur = (e) => {
    if (!e.currentTarget.contains(e.relatedTarget)) {
      onClick();
    }
  };

  return (
    <>
      <div
        className={`nav__expanded-shim  ${open ? 'open' : 'closed'}`}
        onClick={() => {
          handleClick();
        }}
      />
      <div
        className={`nav__expanded ${open ? 'open' : 'closed'}`}
        onBlur={handleBlur}
      >
        <div className="nav__expanded-container" id="extendedMenu">
          <div className="nav__expanded-container_top">
            <div
              className="nav__expanded-links_franchises"
              data-component-id="nav_expanded_franchise_link"
            >
              {mainNav
                .filter((_value, index) => index < 3)
                .map(({ title, url }) => (
                  <Link key={title} to={`${url}/`}>
                    {title}
                  </Link>
                ))}
            </div>
            <div
              className="nav__expanded-links_featured"
              data-component-id="nav_expanded_featured_link"
            >
              {fFeaturedTopics.length > 0 && fFeaturedTopics
                .filter((_value, index) => index < 4)
                .map(({ name, slug, type }) => (
                  <Link key={name} className="animate" to={`/${type}/${slug}/`}>
                    {name}
                  </Link>
                ))}
            </div>
            <div
              className="nav__expanded-links_featured"
              data-component-id="nav_expanded_featured_link"
            >
              {fFeaturedTopics.length > 0 && fFeaturedTopics
                .filter((_value, index) => index >= 4)
                .map(({ name, slug, type }) => (
                  <Link key={name} className="animate" to={`/${type}/${slug}/`}>
                    {name}
                  </Link>
                ))}
            </div>
          </div>
          <div
            className="nav__expanded-container_bottom"
            data-component-id="nav_expanded_container_bottom"
          >
            <div className="nav__expanded-newsletter">
              <Newsletter
                fullContent
                placeholder={newsletterPlaceholder}
                title={newsletterTitle}
              />
            </div>
            <div className="nav__expanded-learn-more">
              {learnMore
                .filter((_value, index) => index < 2)
                .map(({ title, url }) => (
                  <Link key={url} className="underline animate" to={`${url}/`}>
                    {title}
                  </Link>
                ))}
            </div>
            <div className="nav__expanded-learn-more">
              {learnMore
                .filter((_value, index) => index >= 2)
                .map(({ title, url }) => (
                  <Link key={url} className="underline animate" to={`${url}/`}>
                    {title}
                  </Link>
                ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

ExpandedNav.propTypes = {
  data: PropTypes.object,
  onClick: PropTypes.func,
  open: PropTypes.bool.isRequired,
};

export default ExpandedNav;
